import request from '@/utils/request'


// 查询代币任务列列表
export function listTask(query) {
  return request({
    url: '/point/task/list',
    method: 'get',
    params: query
  })
}

// 查询代币任务列分页
export function pageTask(query) {
  return request({
    url: '/point/task/page',
    method: 'get',
    params: query
  })
}

// 查询代币任务列详细
export function getTask(data) {
  return request({
    url: '/point/task/detail',
    method: 'get',
    params: data
  })
}
export function updateVisible(data) {
  return request({
    url: '/point/task/visible',
    method: 'post',
    data: data
  })
}
// 新增代币任务列
export function addTask(data) {
  return request({
    url: '/point/task/add',
    method: 'post',
    data: data
  })
}

// 修改代币任务列
export function updateTask(data) {
  return request({
    url: '/point/task/edit',
    method: 'post',
    data: data
  })
}

// 删除代币任务列
export function delTask(data) {
  return request({
    url: '/point/task/delete',
    method: 'post',
    data: data
  })
}
